export const PENDING_INSPECTION = 1;
export const PENDING_EMISSION = 2;
export const PROCESSING_EMISSION = 3;
export const EMITTED = 4;
export const ERROR_EMISSION = 5;
